var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { permissionSchema } from './jsonSchemas/permission';
import { permissionSchemaValidation } from '../validations.generated';
let Permission = class Permission {
    constructor(resourceType, resourceID, action, level = 0) {
        this.resourceType = resourceType;
        this.resourceID = resourceID;
        this.action = action;
        this.level = level;
        // always valid by definition
        //
        // Does not matter if resourceType = Data and action = PipeAccess
        // database cares - not app??
    }
};
Permission = __decorate([
    JsonSchemaV2(permissionSchema, permissionSchemaValidation)
], Permission);
export { Permission };
//# sourceMappingURL=permission.js.map